(function () {
  'use strict';

  var cartBusy = false;
  var supplementsReady = null;
  var optionSupplement = { id: '', price: 0, label: 'option' };
  var flockSupplement = { id: '', price: 0, label: 'flocage' };
  var legacySupplement = { id: '', price: 0, label: 'supplement' };

  function getConfiguratorForm() {
    return document.getElementById('lp-form');
  }

  function getProductForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getMainVariantId() {
    var productForm = getProductForm();
    var select = productForm && productForm.querySelector('[name="id"]');
    if (select && select.value) return select.value;

    var configForm = getConfiguratorForm();
    return configForm && configForm.dataset.productId ? configForm.dataset.productId : '';
  }

  function getProperties() {
    var props = {};
    document.querySelectorAll('input[data-lp-prop]').forEach(function (input) {
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (match && input.value) props[match[1]] = input.value;
    });
    return props;
  }

  function getOptionUnitPrice() {
    var configForm = getConfiguratorForm();
    return configForm ? (parseFloat(configForm.dataset.optPrice) || 0) : 0;
  }

  function getFlockSurcharge() {
    var selected = document.querySelector('.lp-choice.is-selected[data-group="couleur_flocage"]');
    if (!selected) return 0;
    return parseFloat(selected.dataset.price || '0') || 0;
  }

  function isNonPricedPropertyKey(key) {
    var normalized = String(key).toLowerCase();
    return normalized.indexOf('couleur maillot') !== -1 ||
      normalized === 'taille' ||
      normalized.indexOf('couleur flocage') !== -1;
  }

  function countPaidOptions(props) {
    return Object.keys(props).filter(function (key) {
      return !isNonPricedPropertyKey(key) && !!props[key];
    }).length;
  }

  function fetchVariantById(id) {
    return fetch('/variants/' + id + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function fetchProductByHandle(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function fillSupplementFromVariant(target, variant) {
    if (!variant) return;
    target.id = String(variant.id || '');
    target.price = parseInt(variant.price, 10) || 0;
  }

  function loadSupplement(target, variantId, handle) {
    if (variantId) {
      return fetchVariantById(variantId).then(function (variant) {
        fillSupplementFromVariant(target, variant);
      });
    }

    if (handle) {
      return fetchProductByHandle(handle).then(function (product) {
        if (product && product.variants && product.variants[0]) {
          fillSupplementFromVariant(target, product.variants[0]);
        }
      });
    }

    return Promise.resolve();
  }

  function initSupplements() {
    if (supplementsReady) return supplementsReady;

    supplementsReady = new Promise(function (resolve) {
      var configForm = getConfiguratorForm();
      if (!configForm) return resolve();

      var optionId = (configForm.dataset.optionSupplementId || '').trim();
      var optionHandle = (configForm.dataset.optionSupplementHandle || '').trim();
      var flockId = (configForm.dataset.flockSupplementId || '').trim();
      var flockHandle = (configForm.dataset.flockSupplementHandle || '').trim();
      var legacyId = (configForm.dataset.supplementId || '').trim();
      var legacyHandle = (configForm.dataset.supplementHandle || '').trim();

      Promise.all([
        loadSupplement(optionSupplement, optionId, optionHandle),
        loadSupplement(flockSupplement, flockId, flockHandle),
        loadSupplement(legacySupplement, legacyId, legacyHandle)
      ]).finally(resolve);
    });

    return supplementsReady;
  }

  function buildSupplementItem(supplement, totalCents, properties) {
    if (!supplement.id || !supplement.price) return null;
    if (totalCents <= 0) return null;
    if (totalCents % supplement.price !== 0) return null;

    return {
      id: supplement.id,
      quantity: totalCents / supplement.price,
      properties: properties
    };
  }

  function getAlertMessage() {
    return "Le maillot est bien ajoute, mais les supplements Shopify ne sont pas configures correctement. Renseigne un supplement option a 2 EUR et un supplement flocage a 5 EUR dans le bloc Configurateur.";
  }

  function addConfiguredCart() {
    if (cartBusy) return;

    var mainVariantId = getMainVariantId();
    if (!mainVariantId) {
      alert("Impossible d'ajouter au panier : aucune variante principale n'est selectionnee.");
      return;
    }

    var properties = getProperties();
    var optionCount = countPaidOptions(properties);
    var optionUnitPrice = getOptionUnitPrice();
    var optionTotalCents = Math.round(optionCount * optionUnitPrice * 100);
    var flockTotalCents = Math.round(getFlockSurcharge() * 100);
    var items = [{ id: mainVariantId, quantity: 1, properties: properties }];
    var optionItem = null;
    var flockItem = null;

    if (optionTotalCents > 0) {
      optionItem = buildSupplementItem(optionSupplement, optionTotalCents, {
        '_Supplement type': 'Option configurateur',
        '_Supplement detail': optionCount + ' option(s) x ' + optionUnitPrice.toFixed(2).replace('.', ',') + ' EUR',
        '_Supplement total': (optionTotalCents / 100).toFixed(2).replace('.', ',') + ' EUR'
      });
    }

    if (flockTotalCents > 0) {
      flockItem = buildSupplementItem(flockSupplement, flockTotalCents, {
        '_Supplement type': 'Flocage reflechissant',
        '_Supplement total': (flockTotalCents / 100).toFixed(2).replace('.', ',') + ' EUR'
      });
    }

    if ((optionTotalCents > 0 && !optionItem) || (flockTotalCents > 0 && !flockItem)) {
      var combinedTotalCents = optionTotalCents + flockTotalCents;
      var legacyItem = buildSupplementItem(legacySupplement, combinedTotalCents, {
        '_Supplement personnalisation': optionCount + ' option(s)',
        '_Supplement flocage': (flockTotalCents / 100).toFixed(2).replace('.', ',') + ' EUR',
        '_Supplement total': (combinedTotalCents / 100).toFixed(2).replace('.', ',') + ' EUR'
      });

      if (legacyItem) {
        optionItem = null;
        flockItem = null;
        items.push(legacyItem);
      } else if (optionTotalCents > 0 || flockTotalCents > 0) {
        alert(getAlertMessage());
        return;
      }
    } else {
      if (optionItem) items.push(optionItem);
      if (flockItem) items.push(flockItem);
    }

    cartBusy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add');
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        cartBusy = false;
        alert("Impossible d'ajouter au panier. Verifie la configuration des supplements Shopify.");
      });
  }

  function interceptSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    if (!document.querySelector('[data-lp-config]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    initSupplements().then(addConfiguredCart);
  }

  function interceptClick(event) {
    var button = event.target.closest('.lp-add');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    initSupplements().then(addConfiguredCart);
  }

  document.addEventListener('submit', interceptSubmit, true);
  document.addEventListener('click', interceptClick, true);
  document.addEventListener('DOMContentLoaded', initSupplements);
})();
